import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';

const AdminLayout = () => {
    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Admin Dashboard
                    </Typography>
                    <Button color="inherit" component={Link} to="/admin/dashboard">
                        Home
                    </Button>
                    <Button color="inherit" component={Link} to="/admin/settings">
                        Settings
                    </Button>
                    <Button color="inherit" component={Link} to="/login">
                        Logout
                    </Button>
                </Toolbar>
            </AppBar>
            <Box sx={{ p: 3 }}>
                <Outlet />
            </Box>
        </Box>
    );
};

export default AdminLayout;